/* Add to Cart — Subscribe-first buy box: sub quantity (1/2 pack) + frequency, one-time (3/10 pack) */
(function() {
  'use strict';

  var root = document.querySelector('[data-atc-root]');
  if (!root) return;

  var form = root.querySelector('[data-add-to-cart-form]');
  if (!form) return;

  /* ── DOM refs ─────────────────────────────────── */
  var variantInput     = form.querySelector('[data-variant-input]');
  var sellingPlanInput = form.querySelector('[data-selling-plan-input]');
  var submitBtn        = form.querySelector('.add-to-cart-btn');
  var priceDisplay     = root.querySelector('[data-price-display]');
  var compareDisplay   = root.querySelector('[data-compare-display]');
  var discountBadge    = root.querySelector('[data-discount-badge]');

  var buyOnceCard      = root.querySelector('[data-buy-once]');
  var subscribeCard    = root.querySelector('[data-subscribe-card]');
  var variantCards     = root.querySelectorAll('.variant-card');
  var subQtyPills      = root.querySelectorAll('.sub-qty-pill');
  var planPills        = root.querySelectorAll('.plan-pill');
  var subPriceEl       = root.querySelector('[data-sub-price]');
  var subCompareEl     = root.querySelector('[data-sub-compare]');
  var subPerdayEl      = root.querySelector('[data-sub-perday]');
  var subQtyLabelEl    = root.querySelector('[data-sub-qty-label]');
  var subAfterEl       = root.querySelector('[data-sub-after]');

  /* ── Subscription price map: { variantId: { base, plans: { planId: price } } } ── */
  var subPrices = {};
  var subPricesEl = root.querySelector('[data-sub-plan-prices]');
  if (subPricesEl) {
    try { subPrices = JSON.parse(subPricesEl.textContent); } catch (e) {}
  }
  var hasSub = subscribeCard && Object.keys(subPrices).length > 0;

  /* ── State ────────────────────────────────────── */
  var mode = hasSub ? 'subscribe' : 'onetime';
  var subVariantId    = '';
  var selectedPlanId  = '';
  var onetimeVariantId = '';

  var activeSubPill = root.querySelector('.sub-qty-pill.is-active') || subQtyPills[0];
  if (activeSubPill) {
    subVariantId = activeSubPill.dataset.subVariantId;
    selectedPlanId = activeSubPill.dataset.planId || '';   // each variant carries its OWN plan
  }

  var defaultCard = root.querySelector('.variant-card.is-selected') || variantCards[0];
  if (defaultCard) onetimeVariantId = defaultCard.dataset.variantId;

  /* ── Helpers ──────────────────────────────────── */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function subBase(vId) {
    return subPrices[vId] ? subPrices[vId].base : 0;
  }
  function subPrice(vId, pId) {
    if (subPrices[vId] && subPrices[vId].plans && subPrices[vId].plans[pId] != null) {
      return subPrices[vId].plans[pId];
    }
    return subBase(vId);
  }

  /* ── Mode toggle ──────────────────────────────── */
  function updateMode(newMode) {
    mode = newMode;
    if (buyOnceCard)   buyOnceCard.classList.toggle('is-active', mode === 'onetime');
    if (subscribeCard) subscribeCard.classList.toggle('is-active', mode === 'subscribe');
    syncFormInputs();
    updatePriceDisplay();
  }

  /* ── Keep hidden form inputs in sync with state ── */
  function syncFormInputs() {
    if (mode === 'subscribe' && hasSub) {
      if (variantInput)     variantInput.value = subVariantId;
      if (sellingPlanInput) sellingPlanInput.value = selectedPlanId;
    } else {
      if (variantInput)     variantInput.value = onetimeVariantId;
      if (sellingPlanInput) sellingPlanInput.value = '';
    }
  }

  /* ── Subscription quantity (1 / 2 pack) ───────── */
  function selectSubVariant(vId) {
    subVariantId = vId;
    var sel = null;
    subQtyPills.forEach(function(p) {
      var on = p.dataset.subVariantId === vId;
      p.classList.toggle('is-active', on);
      if (on) sel = p;
    });
    if (sel) selectedPlanId = sel.dataset.planId || '';   // switch to this variant's own plan
    updateSubQtyLabel();
    if (mode === 'subscribe') syncFormInputs();
    updatePlanSaveLabels();
    updatePriceDisplay();
  }

  /* ── Subtitle "1 Pack / 2 Packs each N weeks" ── */
  function updateSubQtyLabel() {
    if (!subQtyLabelEl) return;
    var aq = root.querySelector('.sub-qty-pill.is-active');
    var pack = aq ? (parseInt(aq.dataset.pack, 10) || 1) : 1;
    subQtyLabelEl.textContent = (pack * 48) + ' dots';
  }

  /* ── Delivery frequency ───────────────────────── */
  function selectPlan(pId) {
    selectedPlanId = pId;
    planPills.forEach(function(p) {
      p.classList.toggle('is-active', p.dataset.planId === pId);
    });
    if (mode === 'subscribe') syncFormInputs();
    updatePriceDisplay();
  }

  /* ── One-time variant (3 / 10 pack) ───────────── */
  function selectVariant(vId) {
    onetimeVariantId = vId;
    variantCards.forEach(function(c) {
      c.classList.toggle('is-selected', c.dataset.variantId === vId);
    });
    if (mode === 'onetime') syncFormInputs();
    updatePriceDisplay();
  }

  /* ── Per-plan "Save %" labels (depend on chosen sub variant) ── */
  function updatePlanSaveLabels() {
    var base = subBase(subVariantId);
    planPills.forEach(function(pill) {
      var saveEl = pill.querySelector('[data-plan-save]');
      if (!saveEl) return;
      var price = subPrice(subVariantId, pill.dataset.planId);
      if (base && price < base) {
        saveEl.textContent = 'Save ' + Math.round((base - price) / base * 100) + '%';
        saveEl.style.display = '';
      } else {
        saveEl.textContent = '';
        saveEl.style.display = 'none';
      }
    });
  }

  /* ── Price display (top of buy box + subscribe card) ── */
  function updatePriceDisplay() {
    if (mode === 'subscribe' && hasSub) {
      var activeQ = root.querySelector('.sub-qty-pill.is-active');
      var pack = activeQ ? (parseInt(activeQ.dataset.pack, 10) || 1) : 1;
      var afterV = activeQ ? parseInt(activeQ.dataset.afterPrice, 10) : NaN;
      var introV = activeQ ? parseInt(activeQ.dataset.introPrice, 10) : NaN;

      var base    = subBase(subVariantId);
      var cmpBase = base;   // full regular price, struck through
      var price   = introV > 0 ? introV : subPrice(subVariantId, selectedPlanId);  // first-order price (map-driven)

      if (priceDisplay) priceDisplay.textContent = formatMoney(price);
      if (subPriceEl)   subPriceEl.textContent = formatMoney(price);
      if (subCompareEl) subCompareEl.textContent = cmpBase > price ? formatMoney(cmpBase) : '';

      // per-day — each pack = 48 dots = 24 daily wears
      if (subPerdayEl) {
        subPerdayEl.textContent = formatMoney(price / (24 * pack)) + '/day';
        subPerdayEl.style.display = '';
      }
      // welcome-offer renewal note
      if (subAfterEl) {
        if (afterV > 0) {
          subAfterEl.textContent = 'then ' + formatMoney(afterV) + '/mo';
          subAfterEl.style.display = '';
        } else {
          subAfterEl.style.display = 'none';
        }
      }

      if (compareDisplay) {
        if (cmpBase > price) {
          compareDisplay.textContent = formatMoney(cmpBase);
          compareDisplay.style.display = '';
          if (discountBadge) {
            discountBadge.textContent = Math.round((cmpBase - price) / cmpBase * 100) + '% OFF';
            discountBadge.style.display = '';
          }
        } else {
          compareDisplay.style.display = 'none';
          if (discountBadge) discountBadge.style.display = 'none';
        }
      }
    } else {
      var card = root.querySelector('.variant-card[data-variant-id="' + onetimeVariantId + '"]');
      if (!card) return;
      var p  = parseInt(card.dataset.price, 10);
      var cp = parseInt(card.dataset.comparePrice, 10);
      if (priceDisplay) priceDisplay.textContent = formatMoney(p);
      if (compareDisplay) {
        if (cp && cp > p) {
          compareDisplay.textContent = formatMoney(cp);
          compareDisplay.style.display = '';
          if (discountBadge) {
            discountBadge.textContent = Math.round((cp - p) / cp * 100) + '% OFF';
            discountBadge.style.display = '';
          }
        } else {
          compareDisplay.style.display = 'none';
          if (discountBadge) discountBadge.style.display = 'none';
        }
      }
    }
  }

  /* ── Event listeners ──────────────────────────── */
  if (subscribeCard) {
    subscribeCard.addEventListener('click', function() { updateMode('subscribe'); });
  }
  if (buyOnceCard) {
    buyOnceCard.addEventListener('click', function() { updateMode('onetime'); });
  }
  subQtyPills.forEach(function(pill) {
    pill.addEventListener('click', function(e) {
      e.stopPropagation();
      if (mode !== 'subscribe') updateMode('subscribe');
      selectSubVariant(pill.dataset.subVariantId);
    });
  });
  planPills.forEach(function(pill) {
    pill.addEventListener('click', function(e) {
      e.stopPropagation();
      if (mode !== 'subscribe') updateMode('subscribe');
      selectPlan(pill.dataset.planId);
    });
  });
  variantCards.forEach(function(card) {
    card.addEventListener('click', function(e) {
      e.stopPropagation();
      if (mode !== 'onetime') updateMode('onetime');
      selectVariant(card.dataset.variantId);
    });
  });

  /* ── Form submit — AJAX add to cart ───────────── */
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    if (submitBtn.disabled) return;

    submitBtn.disabled = true;
    var origLabel = submitBtn.textContent;
    submitBtn.textContent = 'Adding...';

    var items = [{ id: variantInput.value, quantity: 1 }];
    if (mode === 'subscribe' && sellingPlanInput && sellingPlanInput.value) {
      items[0].selling_plan = sellingPlanInput.value;
    }

    var upsellCheckbox = root.querySelector('[data-upsell-checkbox]');
    if (upsellCheckbox && upsellCheckbox.checked) {
      items.push({ id: upsellCheckbox.dataset.upsellId, quantity: 1 });
    }

    // Add to cart, then open the drawer cart (no full-page redirect)
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('add failed');
      submitBtn.disabled = false;
      submitBtn.textContent = origLabel;
      document.dispatchEvent(new CustomEvent('cart:open'));
    })
    .catch(function() {
      submitBtn.disabled = false;
      submitBtn.textContent = origLabel;
      alert('Sorry — something went wrong adding to cart. Please try again.');
    });
  });

  /* ── Expandable sections ──────────────────────── */
  document.querySelectorAll('.expandable-section__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var section = trigger.closest('.expandable-section');
      section.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', section.classList.contains('is-open'));
    });
  });

  /* ── Initialize ───────────────────────────────── */
  updateSubQtyLabel();
  updatePlanSaveLabels();
  syncFormInputs();
  updatePriceDisplay();

  // Deep-link: #subscribe focuses the subscribe card
  if (window.location.hash === '#subscribe' && subscribeCard) {
    updateMode('subscribe');
    setTimeout(function() {
      subscribeCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 300);
  }

})();
